module.exports = __webpack_public_path__ + "media/metronic/_theme/media/illustrations/data-points-bfcf7654907e4ad601c44233006bfa2b.svg";